(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-slideshow"] && !Shopify.designMode) return;
  try {
    
(() => { const init = () => { document.querySelectorAll('.banner-slideshow').forEach((root) => { if (root.dataset.initialized === 'true') return; root.dataset.initialized='true'; const slides=[...root.querySelectorAll('[data-slide-index]')], dots=[...root.querySelectorAll('[data-slide-to]')], autoplay=root.dataset.autoplay==='true', interval=Number(root.dataset.interval)||5000; let current=0,timer; const show=(index)=>{current=(index+slides.length)%slides.length;slides.forEach((slide,i)=>{const active=i===current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',active?'false':'true')});dots.forEach((dot,i)=>{const active=i===current;dot.classList.toggle('is-active',active);dot.setAttribute('aria-selected',active?'true':'false')})}; const restart=()=>{window.clearInterval(timer);if(autoplay&&slides.length>1)timer=window.setInterval(()=>show(current+1),interval)}; root.querySelector('[data-previous]')?.addEventListener('click',()=>{show(current-1);restart()});root.querySelector('[data-next]')?.addEventListener('click',()=>{show(current+1);restart()});dots.forEach(dot=>dot.addEventListener('click',()=>{show(Number(dot.dataset.slideTo));restart()}));root.addEventListener('mouseenter',()=>window.clearInterval(timer));root.addEventListener('mouseleave',restart);show(0);restart() }) }; if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init() })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
